<div class="router-container">
    <router-outlet></router-outlet>
</div>
